module.exports = __webpack_public_path__ + "static/img_1.d05784c1.png";